export default {
  idle: 0,
  destroyed: 2,
}
